/* eslint-disable */
import createIcon from '../createIcon';

const IconUpOutlined = createIcon({
  name: 'icon-up-outlined',
  content: '<path d="M512.955818 321.154947h-0.637212L196.898569 636.574984l45.879278 45.879279 270.177971-270.815184 270.177972 270.815184 45.242066-45.879279-315.420038-315.420037z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconUpOutlined;
